import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const SwarmSchema = z.object({
	id: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	jobTitles: z.array(z.string()).nullable(),
	excludeJobTitles: z.array(z.string()).nullable(),
	jobLevels: z.array(z.string()).nullable(),
	countries: z.array(z.string()).nullable(),
	cities: z.array(z.string()).nullable(),
	states: z.array(z.string()).nullable(),
	companyNames: z.array(z.string()).nullable(),
	excludeCompanyNames: z.array(z.string()).nullable(),
	companySizes: z.array(z.string()).nullable(),
	companyIndustries: z.array(z.string()).nullable(),
	companyWebsites: z.array(z.string()).nullable(),
	companyCountries: z.array(z.string()).nullable(),
	companyStates: z.array(z.string()).nullable(),
	companyCities: z.array(z.string()).nullable(),
	schoolNames: z.array(z.string()).nullable(),
	pastEmployers: z.array(z.string()).nullable(),
	yearsInCurrentRole: z.number().nullable(),
	linkedinSlugs: z.array(z.string()).nullable(),
});

export const CreateSwarmSchema = z.object({
	id: z.number().optional(),
	listId: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	jobTitles: z.array(z.string()).nullable(),
	excludeJobTitles: z.array(z.string()).nullable(),
	jobLevels: z.array(z.string()).nullable(),
	countries: z.array(z.string()).nullable(),
	cities: z.array(z.string()).nullable(),
	states: z.array(z.string()).nullable(),
	companyNames: z.array(z.string()).nullable(),
	excludeCompanyNames: z.array(z.string()).nullable(),
	companySizes: z.array(z.string()).nullable(),
	companyIndustries: z.array(z.string()).nullable(),
	companyWebsites: z.array(z.string()).nullable(),
	companyCountries: z.array(z.string()).nullable(),
	companyStates: z.array(z.string()).nullable(),
	companyCities: z.array(z.string()).nullable(),
	schoolNames: z.array(z.string()).nullable(),
	pastEmployers: z.array(z.string()).nullable(),
	yearsInCurrentRole: z.number().nullable(),
	linkedinSlugs: z.array(z.string()).nullable().optional(),
});

export const SwarmResponseSchema = z.object({
	data: z.array(SwarmSchema),
	meta: MetaDataSchema,
});

export type Swarm = z.infer<typeof SwarmSchema>;
export type SwarmResponse = z.infer<typeof SwarmResponseSchema>;

export type CreateSwarm = z.infer<typeof CreateSwarmSchema>;
